import React from 'react';
import {get} from 'lodash';
import moment from 'moment';

import TableHeader from './TableHeader';

const columnHeaders = [
  {label: 'ID'},
  {label: 'Admin'},
  {label: 'Resource ID'},
  {label: 'Resource Type'},
  {label: 'Created At', sortKey: 'created_at'},
]

const AdminViewLogList = ({
  logs = [],
  total = 0,
}) => {

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Admin View logs</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} logs</p>
        </div>
      </div>

      <div className='Table Table--admin-view-logs'>
        <div className='Table__row'>
          {columnHeaders.map((header, key) => (
            <TableHeader
              key={key}
              header={header}
            />
          ))}
        </div>

        {logs.map((log) => (
          <div key={log.id} className='Table__row'>
            <div className='Table__col'>{get(log, 'id')}</div>
            <div className='Table__col'>{get(log, 'email')}</div>
            <div className='Table__col'>{get(log, 'resourceId')}</div>
            <div className='Table__col'>{get(log, 'resourceType')}</div>
            <div className="Table__col">
              {log.createdAt !== null ? moment(log.createdAt).format('YYYY-MM-DD HH:mm') : 'N/A'}
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default AdminViewLogList;
